import  CoverageCard from './CoverageCard';

export default CoverageCard